import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import Error from "../Component/Error";
import config from "../config";
import "./ClickToCall.css";

function ClickToCall() {
  const [ui, setUi] = useState("");
  const [customerInfo, setCustomerInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const { randKey, compId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {
          data: { userToken: token },
        } = await axios.post(`${config.API_URL}/ms/gettoken`);

        const { data } = await axios.get(
          `${config.API_URL}/customer/clicktocallinfo/${randKey}/clicktocall`,
          { headers: { Authorization: token } }
        );

        const campDID = data?.campDID ? Object.values(data?.campDID) : [];
        setCustomerInfo({
          name: data?.CUSTOMER_NAME,
          policyNumber: data?.POLICY,
          logo: data?.LOGO_NAME,
          image: data?.IMAGE_NAME,
          clickText: data?.CLICK_TEXT,
          footerText: data?.FOOTER_TEXT,
          campDIDText:
            campDID.length > 0 ? campDID.join(", ") : "No numbers available",
        });
      } catch (err) {
        setUi(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [randKey, compId]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh", backgroundColor: "#f8f9fa" }}
      >
        <div
          className="spinner-border text-primary"
          style={{ width: "3rem", height: "3rem" }}
          role="status"
        >
          <span className="visually-hidden"></span>
        </div>
      </div>
    );
  }

  const ResponseMessage = ({ message, customerName }) => {
    const formattedMessage = message.replace("{customer_name}", customerName);

    return (
      <div
        className="cardCTC-text"
        dangerouslySetInnerHTML={{ __html: formattedMessage }}
      />
    );
  };

  return (
    <>
      {customerInfo ? (
        <div className="page-wrapper">
          <div className="page-content">
            <div className="container">
              <div
                className="cardCTC clickBoard"
                style={{ borderRadius: "15px" }}
              >
                <div
                  className="cardCTC-header text-left  "
                  style={{
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                    textAlignLast: "center",
                  }}
                >
                  <img
                    src={customerInfo.logo}
                    alt="Company Logo"
                    className="img-fluid"
                    style={{
                      height: "40px",
                    }}
                  />
                </div>

                <div className="cardCTC-body" style={{ padding: "0" }}>
                  <div className="row">
                    <div className="col-12 col-s-12 col-md-6 col-lg-6">
                      <img
                        src={customerInfo?.image}
                        alt="Thank you"
                        style={{
                          width: "100%",
                          maxWidth: "500px",
                          height: "auto",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <div className="col-12 col-s-12 col-md-6 col-lg-6 d-flex justify-content-center align-items-start">
                      <div
                        className="cardCTC"
                        style={{
                          backgroundColor: "#ffffff",
                          margin: "calc(5vw + 20px)",
                          width: "auto",
                          maxWidth: "100%",
                          borderRadius: "15px",
                        }}
                      >
                        <div style={{ padding: "20px" }}>
                          <div className="cardCTC-text mb-2">
                            <ResponseMessage
                              message={customerInfo?.clickText}
                              customerName={customerInfo?.name}
                            />
                            <strong>{customerInfo?.campDIDText}</strong>.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="cardCTC-footer text-center pt-4"
                    style={{
                      borderBottomLeftRadius: "15px",
                      borderBottomRightRadius: "15px",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "Gabriola",
                        fontSize: "16px",
                      }}
                    >
                      <span style={{ color: "red" }}>*</span>{" "}
                      {customerInfo.footerText}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Error msg={ui.message || "Failed to load customer information."} />
      )}
    </>
  );
}

export default ClickToCall;
